
const template = document.createElement('template');
template.innerHTML = `
<style>
    :host {
        position: absolute;
        top: 80px;
        left: 20px;
        display: block;
        width: 280px;
        background: rgba(20, 20, 20, 0.95);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 8px;
        padding: 0;
        color: #eee;
        font-family: 'Courier New', monospace;
        user-select: none;
        box-sizing: border-box;
        backdrop-filter: blur(10px);
        box-shadow: 0 4px 20px rgba(0,0,0,0.5);
        z-index: 95;
        transition: height 0.3s ease-out;
        overflow: hidden;
        max-height: 80vh;
        display: flex;
        flex-direction: column;
    }

    /* Scrollbar for grid if it gets too tall */
    ::-webkit-scrollbar { width: 6px; }
    ::-webkit-scrollbar-track { background: rgba(0,0,0,0.3); }
    ::-webkit-scrollbar-thumb { background: #444; border-radius: 3px; }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 10px;
        background: rgba(255, 255, 255, 0.05);
        cursor: grab;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        flex-shrink: 0;
    }
    .header:active { cursor: grabbing; }
    .title { font-weight: bold; font-size: 0.9rem; color: #ccc; }
    
    .fold-btn {
        background: transparent;
        border: none;
        color: #aaa;
        cursor: pointer;
        padding: 0;
        transition: transform 0.2s;
    }
    :host(.folded) .fold-btn { transform: rotate(-90deg); }

    .controls-panel {
        padding: 10px;
        border-bottom: 1px solid rgba(255,255,255,0.1);
        background: rgba(0,0,0,0.2);
        flex-shrink: 0;
    }

    .controls-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 8px;
        flex-wrap: wrap;
    }

    .btn {
        background: #333;
        border: 1px solid #555;
        color: #fff;
        padding: 4px 10px;
        cursor: pointer;
        font-size: 10px;
        border-radius: 4px;
        text-transform: uppercase;
        flex: 1;
        text-align: center;
    }
    .btn:hover { background: #444; }
    .btn.active {
        background: var(--primary-color, #00ffcc);
        color: #000;
        border-color: var(--primary-color, #00ffcc);
        box-shadow: 0 0 8px var(--primary-color, #00ffcc);
    }
    
    .grid {
        display: flex;
        flex-direction: column;
        gap: 2px;
        padding: 5px;
        overflow-y: auto;
        flex: 1;
    }

    .step {
        display: flex;
        align-items: center;
        background: rgba(255,255,255,0.03);
        border-radius: 4px;
        padding: 4px;
        height: 32px;
        gap: 8px;
        border: 1px solid transparent;
    }
    .step.current {
        background: rgba(var(--primary-color-rgb, 0, 255, 204), 0.15);
        border-color: var(--primary-color, #00ffcc);
        box-shadow: inset 0 0 5px rgba(var(--primary-color-rgb, 0, 255, 204), 0.3);
    }

    .step-num {
        font-size: 9px;
        color: #888;
        width: 14px;
        text-align: right;
        font-weight: bold;
    }

    .step-toggle {
        width: 18px;
        height: 18px;
        background: #222;
        border: 1px solid #444;
        border-radius: 2px;
        cursor: pointer;
        flex-shrink: 0;
    }
    .step-toggle.active {
        background: var(--primary-color, #00ffcc);
        box-shadow: 0 0 8px var(--primary-color, #00ffcc);
        border-color: #fff;
    }

    .sliders-group {
        display: flex;
        flex-direction: column;
        flex: 1;
        gap: 1px;
    }

    .slider-row {
        display: flex;
        align-items: center;
        gap: 6px;
    }
    
    .slider-label {
        font-size: 9px;
        color: #666;
        width: 12px;
        text-align: center;
        font-weight: bold;
    }

    input[type=range] {
        -webkit-appearance: none;
        width: 100%;
        height: 3px;
        background: #333;
        outline: none;
        border-radius: 2px;
        cursor: pointer;
    }
    input[type=range]::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 10px;
        height: 10px;
        background: #888;
        border-radius: 50%;
        border: 1px solid #222;
    }
    input[type=range]:hover::-webkit-slider-thumb { background: #fff; border-color: #000; }

    /* Specific sliders */
    .pitch-slider::-webkit-slider-thumb { background: #00aaff; }
    .vel-slider::-webkit-slider-thumb { background: #ffaa00; }
    .gate-slider::-webkit-slider-thumb { background: #00ff88; }

    .val-disp { font-size: 10px; font-weight: bold; width: 25px; text-align: right; color: #aaa; }
    
    select {
        background: #222;
        color: #fff;
        border: 1px solid #444;
        padding: 2px;
        font-size: 10px;
        width: 100%;
    }
</style>

<div class="header" id="header">
    <span class="title">SEQUENCER</span>
    <button class="fold-btn" id="fold-btn">
        <svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/></svg>
    </button>
</div>

<div class="controls-panel" id="controls">
    <div class="controls-row">
        <button class="btn" id="play-btn">PLAY</button>
        <div style="display:flex; align-items:center; gap:5px; flex:1; justify-content: flex-end;">
            <label style="font-size:10px; color:#aaa;">BPM</label>
            <span id="bpm-val" class="val-disp">120</span>
            <input type="range" id="bpm-slider" min="60" max="240" value="120" style="width: 60px;">
        </div>
    </div>

    <div class="controls-row">
        <button class="btn active" id="mode-seq" data-mode="seq">SEQ</button>
        <button class="btn" id="mode-arp" data-mode="arp">ARP</button>
    </div>

    <div class="controls-row" id="arp-options" style="display:none;">
        <select id="arp-style">
            <option value="up">UP</option>
            <option value="down">DOWN</option>
            <option value="updown">UP/DOWN</option>
            <option value="random">RANDOM</option>
            <option value="chord">CHORD</option>
        </select>
    </div>
</div>

<div class="grid" id="seq-grid">
    <!-- Generated Steps -->
</div>
`;

export class SequencerUI extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        
        this.sequencer = null;
        this.grid = this.shadowRoot.getElementById('seq-grid');
        this.header = this.shadowRoot.getElementById('header');
        this.foldBtn = this.shadowRoot.getElementById('fold-btn');
        this.controlsPanel = this.shadowRoot.getElementById('controls');
        
        // Controls
        this.playBtn = this.shadowRoot.getElementById('play-btn');
        this.bpmSlider = this.shadowRoot.getElementById('bpm-slider');
        this.bpmVal = this.shadowRoot.getElementById('bpm-val');
        this.arpOptions = this.shadowRoot.getElementById('arp-options');
        this.arpStyle = this.shadowRoot.getElementById('arp-style');
        
        this.steps = []; 
        
        // Drag State
        this.isDragging = false;
        this.dragOffset = { x: 0, y: 0 };
        this.collapsed = false;
    }

    connectedCallback() {
        this.renderGrid();
        this.setupListeners();
        this.setupDrag();
        
        // Stop propagation to prevent interacting with the surface below
        this.addEventListener('mousedown', e => e.stopPropagation());
        this.addEventListener('touchstart', e => e.stopPropagation(), { passive: false });
        this.addEventListener('click', e => e.stopPropagation());
    }

    setSequencer(seq) {
        this.sequencer = seq;
        this.bpmSlider.value = seq.bpm;
        this.bpmVal.textContent = seq.bpm;
        
        seq.steps.forEach((stepData, i) => {
            if (this.steps[i]) {
                this.steps[i].toggle.classList.toggle('active', stepData.active);
                this.steps[i].pitch.value = stepData.pitch;
                this.steps[i].velocity.value = stepData.velocity;
                this.steps[i].gate.value = stepData.gate;
            }
        });

        seq.onStepChange = (idx) => this.highlightStep(idx);
    }

    renderGrid() {
        this.grid.innerHTML = '';
        this.steps = [];

        for (let i = 0; i < 16; i++) {
            const el = document.createElement('div');
            el.className = 'step';
            
            // 1. Number
            const num = document.createElement('span');
            num.className = 'step-num';
            num.textContent = i + 1;
            el.appendChild(num);

            // 2. Toggle
            const toggle = document.createElement('div');
            toggle.className = 'step-toggle';
            el.appendChild(toggle);

            // 3. Sliders Group
            const group = document.createElement('div');
            group.className = 'sliders-group';

            // Helper to create slider row
            const createSlider = (cls, label, min, max, val, stepVal, title) => {
                const row = document.createElement('div');
                row.className = 'slider-row';
                
                const lbl = document.createElement('span');
                lbl.className = 'slider-label';
                lbl.textContent = label;
                row.appendChild(lbl);

                const input = document.createElement('input');
                input.type = 'range';
                input.className = cls;
                input.min = min;
                input.max = max;
                input.value = val;
                input.step = stepVal;
                input.title = title;
                row.appendChild(input);
                return { row, input };
            };

            const pitch = createSlider('pitch-slider', '♯', -12, 12, 0, 1, 'Pitch');
            const vel = createSlider('vel-slider', 'V', 0, 1, 0.7, 0.01, 'Velocity');
            const gate = createSlider('gate-slider', '◷', 0.1, 1, 0.5, 0.01, 'Gate Length');

            group.appendChild(pitch.row);
            group.appendChild(vel.row);
            group.appendChild(gate.row);
            el.appendChild(group);

            this.grid.appendChild(el);
            
            this.steps.push({
                el: el,
                toggle: toggle,
                pitch: pitch.input,
                velocity: vel.input,
                gate: gate.input
            });

            // Listeners
            toggle.addEventListener('click', () => {
                const isActive = toggle.classList.toggle('active');
                if (this.sequencer) this.sequencer.setStep(i, isActive);
            });

            const updateData = () => {
                if (this.sequencer) {
                    this.sequencer.setStepData(i, {
                        pitch: parseInt(pitch.input.value),
                        velocity: parseFloat(vel.input.value),
                        gate: parseFloat(gate.input.value)
                    });
                }
            };

            pitch.input.addEventListener('input', updateData);
            vel.input.addEventListener('input', updateData);
            gate.input.addEventListener('input', updateData);
        }
    }

    setupListeners() {
        this.playBtn.addEventListener('click', () => {
            if (!this.sequencer) return;
            this.sequencer.toggle();
            this.playBtn.classList.toggle('active', this.sequencer.isPlaying);
            this.playBtn.textContent = this.sequencer.isPlaying ? "STOP" : "PLAY";
        });

        this.bpmSlider.addEventListener('input', (e) => {
            const val = parseInt(e.target.value);
            this.bpmVal.textContent = val;
            if (this.sequencer) this.sequencer.setBpm(val);
        });

        const modeSeq = this.shadowRoot.getElementById('mode-seq');
        const modeArp = this.shadowRoot.getElementById('mode-arp');

        modeSeq.addEventListener('click', () => {
            modeSeq.classList.add('active');
            modeArp.classList.remove('active');
            this.arpOptions.style.display = 'none';
            if (this.sequencer) this.sequencer.arpEnabled = false;
        });

        modeArp.addEventListener('click', () => {
            modeArp.classList.add('active');
            modeSeq.classList.remove('active');
            this.arpOptions.style.display = 'flex';
            if (this.sequencer) this.sequencer.arpEnabled = true;
        });

        this.arpStyle.addEventListener('change', (e) => {
            if (this.sequencer) this.sequencer.setArpMode(e.target.value);
        });

        this.foldBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleFold();
        });
    }

    setupDrag() {
        this.header.addEventListener('mousedown', (e) => this.startDrag(e));
        window.addEventListener('mousemove', (e) => this.drag(e));
        window.addEventListener('mouseup', () => this.stopDrag());
    }

    toggleFold() {
        this.collapsed = !this.collapsed;
        if (this.collapsed) {
            this.classList.add('folded');
            // Header height + border approx 38px
            this.style.height = '38px'; 
            this.style.overflow = 'hidden';
        } else {
            this.classList.remove('folded');
            this.style.height = 'auto';
            this.style.overflow = 'visible'; // Allow overflow if needed, or keeping hidden works if flex
            // Recalculate max-height logic or just remove explicit height to let it grow?
            // "height: auto" works if we remove fixed height.
        }
    }

    startDrag(e) {
        if (e.target.closest('.fold-btn')) return;
        this.isDragging = true;
        const rect = this.getBoundingClientRect();
        this.dragOffset.x = e.clientX - rect.left;
        this.dragOffset.y = e.clientY - rect.top;
        this.style.cursor = 'grabbing';
    }

    drag(e) {
        if (!this.isDragging) return;
        e.preventDefault();
        const x = e.clientX - this.dragOffset.x;
        const y = e.clientY - this.dragOffset.y;
        
        this.style.left = `${x}px`;
        this.style.top = `${y}px`;
        this.style.transform = 'none'; // Clear centering if present
    }

    stopDrag() {
        this.isDragging = false;
        this.style.cursor = 'default';
    }

    highlightStep(idx) {
        const prev = this.shadowRoot.querySelector('.step.current');
        if (prev) prev.classList.remove('current');
        if (this.steps[idx]) {
            this.steps[idx].el.classList.add('current');
            // Auto-scroll to step?
            // this.steps[idx].el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
    }
}

customElements.define('sequencer-ui', SequencerUI);
